import { render } from "./ContentOptionsModal.vue?vue&type=template&id=1cffcf4e&ts=true"
import script from "./ContentOptionsModal.vue?vue&type=script&lang=ts"
export * from "./ContentOptionsModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__